import { render, staticRenderFns } from "./re-fabric-group.vue?vue&type=template&id=77bdb7c2"
import script from "./re-fabric-group.vue?vue&type=script&lang=ts"
export * from "./re-fabric-group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports